import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import backIconImg from '../../../../../assets/BackNavBtn.svg'
import coinIconImg from '../../../../../assets/coin.svg'
import { useIsMobile } from '../../../../../hooks/useIsMobile'
import { setShowPurchaseCoins } from '../../../../../redux/designerReducers/designerReducer'
import {
  Back,
  Balance,
  Header,
  HeaderRow,
  Refill,
  Title
} from './DcoinstHistory.styles'

export const DcoinsHistoryHeader = ({ isOpen, handleClose }) => {
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const me = useSelector(state => state.profile.me)
  const handleRefill = () => {
    if (isMobile) handleClose()
    dispatch(setShowPurchaseCoins(true))
  }

  return (
    <Header>
      <HeaderRow>
        <Back onClick={handleClose}>
          <img src={backIconImg} alt="" />
        </Back>
        <Title>My Balance</Title>
      </HeaderRow>
      <HeaderRow>
        <img src={coinIconImg} alt="" width={40} height={40} />{' '}
        <Balance>{new Intl.NumberFormat().format(me?.numCoins)}</Balance>
        <Refill onClick={handleRefill}>Refill</Refill>
      </HeaderRow>
    </Header>
  )
}
